import script from "./time.vue?vue&type=script&setup=true&lang=js"
export * from "./time.vue?vue&type=script&setup=true&lang=js"

import "./time.vue?vue&type=style&index=0&id=537be3b7&scoped=true&lang=css"

import exportComponent from "D:\\D盘\\桌面\\项目\\王者荣耀后台管理系统\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-537be3b7"]])

export default __exports__